/**
 * Misc small behaviors that don’t justify their own module (keep it small).
 *
 * Put here:
 * - Attribute-driven helpers (e.g. [setBackground])
 * - Small, isolated DOM behaviors
 *
 * Avoid here:
 * - Anything that grows big: split into a dedicated module as soon as it does
 */
export function initMisc() {
	// Background images
	const mq = window.matchMedia("(max-width: 576px)");

	function applyBackground(el, isMobile) {
		const mobileUrl = el.getAttribute("setBackgroundMobile");
		const desktopUrl = el.getAttribute("setBackground");
		const url = (isMobile && mobileUrl) ? mobileUrl : desktopUrl;
		if (url) {
			el.style.backgroundImage = `url(${url})`;
			el.style.backgroundSize = 'cover';
		}
	}

	const bgEls = [...document.querySelectorAll("[setBackground]")];
	bgEls.forEach((el) => applyBackground(el, mq.matches));
	mq.addEventListener("change", (e) => bgEls.forEach((el) => applyBackground(el, e.matches)));





	// Counter (if exists)
	const counters = document.querySelectorAll(".counter");
	const counterUp = window.counterUp?.default;

	if (counters.length && counterUp) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !entry.target.classList.contains("done")) {
					counterUp(entry.target, { duration: 2000, delay: 200 });
					entry.target.classList.add("done");
				}
			});
		});

		counters.forEach((c) => observer.observe(c));
	}

	new MappingListener({
		selector: "header .btn-booking",
		mobileWrapper: ".mobile-nav-wrap",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-top-menu",
		desktopMethod: "insertBefore",
		breakpoint: 1200.1,
	}).watch();



}